import Vue from 'vue';
import App from './app.vue';
import iView from 'iview';
import { router } from './router/index';
import 'famfamfam-flags/dist/sprite/famfamfam-flags.css';
import Ajax from './lib/ajax';
import Util from './lib/util';
import appConst from './lib/appconst'
import SignalRAspNetCoreHelper from './lib/SignalRAspNetCoreHelper';

import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import "@/lib/vueFilters";
import {globalMixin} from '@/lib/gMixin'

// import Viser from 'viser-vue'
// Vue.use(Viser)

Vue.mixin(globalMixin);

// Vue.use(iView);
Vue.use(Antd);
import store from './store/index';
Vue.config.productionTip = false;
import { appRouters } from './router/router';
import util from './lib/util';
if (!abp.utils.getCookieValue('Abp.Localization.CultureName')) {
  let language = navigator.language;
  abp.utils.setCookieValue('Abp.Localization.CultureName', language, new Date(new Date().getTime() + 5 * 365 * 86400000), abp.appPath);
}


const EventBus = new Vue()
Object.defineProperties(Vue.prototype, {
  $bus: {
    get: function () {
        return EventBus;
    }
  }
});

Ajax.get('web/user/GetLoginUserId').then(data => {
  let userId = data.data.data;
  if(userId!=0){
    let combineData = {
      currentUser:userId
    }
    Util.abp=Util.extend(true,Util.abp,combineData);
  }
  new Vue({
    render: h => h(App),
    router: router,
    store: store,
    data: {
      currentPageName: ''
    },
    async mounted() {

      //this.currentPageName = this.$route.name as string;
      await this["$store"].dispatch({
        type:'session/init',
        userId:userId
      })
    },
    created() {
    }
  }).$mount('#app')
})


